import type { UpdateActivityInputType } from '../constants'
import React, { type FormEventHandler, useEffect } from 'react'
import { useError, useMutation } from '@ztechapps/common.hook'
import { ShowIf } from '@ztechapps/webui.util'
import { ButtonGroup, Stack } from 'react-bootstrap'
import { TextAreaInput } from '@ztechapps/webui.input'
import { BusyButton } from '@ztechapps/webui.button'
import { placeholder } from './AddActivityInput'
import type { Activity } from '@ztechapps/common.contract'
import { mutationUpdateRemarksActivity } from '../graphql'
import { useActivityContext } from '../Context'

export const UpdateActivityInput = ({ activity, afterSave }: UpdateActivityInputType) => {
  const { entityName, documentId, disabled, onKeyDown, reset } = useActivityContext()
  const updateMutation = useMutation<Activity>({ query: mutationUpdateRemarksActivity(entityName) })

  const [newActivity, setNewActivity] = React.useState('')
  const [onUpdate, , { loading, error }] = updateMutation ?? []
  const activityId = activity?._id
  const initialActivity = activity?.activity ?? ''

  useError(error)

  useEffect(() => {
    if (initialActivity) {
      setNewActivity(initialActivity)
    }
  }, [initialActivity])

  const onSubmit: FormEventHandler<any> = async (e) => {
    e.preventDefault()

    //if there is a value for activityId, then update the activity
    onUpdate({
      filter: {
        _id: documentId,
        'remarksActivity._id': activityId,
      },
      input: { activity: newActivity },
    })

    handleReset()
  }

  const handleReset = () => {
    reset()
    setNewActivity('')
    afterSave()
  }

  return (
    <ShowIf condition={!disabled}>
      <form onSubmit={onSubmit} onReset={handleReset}>
        <Stack gap={2}>
          <TextAreaInput
            placeholder={placeholder}
            disabled={loading}
            onChange={(e) => setNewActivity(e.target.value)}
            value={newActivity}
            onKeyDown={(e) => {
              onKeyDown(e, onSubmit)
            }}
          />
          <div>
            <ButtonGroup size="sm">
              <BusyButton
                type="submit"
                disabled={!newActivity}
                isBusy={loading}
                text="Save"
                icon="save"
                busyText="Saving..."
                title="Update activity"
              />
              <BusyButton type="reset" text="Cancel" icon="ban" title="Cancel changes" bsStyle="secondary" />
            </ButtonGroup>
          </div>
        </Stack>
      </form>
    </ShowIf>
  )
}
